import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { getFileType } from "../../../utils/fileHelpers";
import shared from "../../../utils/shared";
import ReactPlayerWrapper from "../../Slideshow/ReactPlayerWrapper";

class SlideshowOmaha extends Component {
  constructor(props) {
    super(props);

    this._totalElements = this.props.module.contents.images.length;
    this._cycleOverrides = this.props.module.contents.cycle_overrides;
    this._currentDuration = 0;
    this._startSlideTime = 0;
    this._lastTakenSlideIndex = -1;
    this._nextGroup = [];
    this._paused = false;
    this.state = {
      videoVolumes: Array.from(Array(this.props.module.contents.images.length), () => 0),
      module: this.props.module
    };
  }

  componentWillMount() {
    shared.checkData(this.props.module);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    this.slidesChanged();
  }

  componentWillUnmount() {
    this.clearCycleTimeout();
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  clearCycleTimeout = () => {
    clearTimeout(this._cycleTimeout);
    this._cycleTimeout = null;
  };

  slidesChanged = () => {
    let timeout = 5000;
    let hScreens = this.props.module.contents.hScreens;
    let vScreens = this.props.module.contents.vScreens;
    if (hScreens && Number(hScreens) !== 0) {
      hScreens = Number(hScreens);
    } else {
      hScreens = 1;
    }
    if (vScreens && Number(vScreens) !== 0) {
      vScreens = Number(vScreens);
    } else {
      vScreens = 1;
    }

    this._nextGroup = [];

    // default to all slides clone array
    let slidePool = this.props.module.contents.images.slice(0);
    if (this.props.module.contents.bool0s) {
      // clear slidePool to use active inactive bools
      slidePool = [];
      // push active slides into pool
      this.props.module.contents.images.forEach((image, index) => {
        if (this.props.module.contents.bool0s && this.props.module.contents.bool0s[index] === true) {
          slidePool.push(image);
        }
      });
    }

    this._totalElements = slidePool.length;

    const returnModule = _.cloneDeep(this.props.module);
    returnModule.contents.images = slidePool;

    let totalImagesNeeded = hScreens * vScreens;

    if (totalImagesNeeded > slidePool.length) {
      return null;
    }

    let index = 0;

    let imageHeight = this.props.screen.screenHeight / vScreens;
    let imageWidth = this.props.screen.screenWidth / hScreens;

    for (let i = 0; i < totalImagesNeeded; i++) {
      index = (i + this._lastTakenSlideIndex + 1) % this._totalElements;

      let imageStyle = {
        top: Math.floor(i / hScreens) * imageHeight,
        left: (i % hScreens) * imageWidth,
        maxHeight: imageHeight,
        maxWidth: imageWidth
      };

      this._nextGroup.push({
        index: index,
        style: imageStyle
      });

      if (i === totalImagesNeeded - 1) {
        if (this._cycleOverrides[index]) {
          timeout = this._cycleOverrides[index] * 1000;
        }
        this._lastTakenSlideIndex = index;
      }
    }

    this.clearCycleTimeout();
    this._cycleTimeout = setTimeout(() => {
      this.slidesChanged();
    }, timeout);

    this.setState({
      group: this._nextGroup,
      module: returnModule,
      lastTakenSlideIndex: this._lastTakenSlideIndex
    });
  };

  getSlides = () => {
    let volume = 1;

    if (this.props.idle) {
      volume = 0;
    }
    return this._nextGroup.map((slide, row) => {
      let fileType = getFileType(this.state.module.contents.images[slide.index].file_name);
      if (fileType === "Image") {
        return (
          <img
            key={row}
            alt="Slide"
            onMouseDown={this.preventDrag}
            className="nodrag"
            style={{ ...slide.style, backgroundSize: 'cover' }}
            src={shared.dp(this.props.screen, this.state.module.contents.images[slide.index])}
          />
        );
      } else {
        return (
          <ReactPlayerWrapper
            playing={!this._paused}
            handleVideoDuration={this.handleVideoDuration}
            volume={volume}
            onEnded={this.videoEnded}
            key={slide.index}
            url={shared.dp(this.props.screen, this.state.module.contents.images[slide.index])}
            width={this.props.screen.screenWidth}
            height={this.props.screen.screenHeight}
          />
        );
      }
    });
  };

  render() {
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: this.props.screen.screenWidth,
          height: this.props.screen.screenHeight,
          pointerEvents: "none"
        }}
        className="nodrag"
      >
        <CSSTransitionGroup
          component="div"
          transitionName="fastfadedelay"
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}
        >
          <div key={this.state.lastTakenSlideIndex} style={{ position: "absolute", left: 0, top: 0 }}>
            {this.getSlides()}
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    screen: state.screen
  };
};

export default connect(mapStateToProps, null)(SlideshowOmaha);



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/SlideshowOmaha.jsx